import { useViewsContext, useGlobalizationContext, useTranslation } from '@cs-cms/state-management';
import { DEFAULT_FACETS_COUNT, CpsFieldRequest, UpdateViewRequest } from '@cs-cms/types';
import { ICpsDialogProps } from '../../../common/useCpsDialog';

interface UseSystemViewUpdateProps {
  showDialog: (props: ICpsDialogProps) => void;
}

export const useSystemViewUpdate = ({ showDialog }: UseSystemViewUpdateProps) => {
  const { selectedView, selectedViewData, editingViewState, onUpdateView, setHasUnsavedChanges } = useViewsContext();
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const handleUpdateView = () => {
    if (!selectedView || !selectedViewData || !onUpdateView) {
      return;
    }

    const fields = editingViewState.fields.map(
      field =>
        ({
          id: field.id,
          width: field.width,
          freezed: false,
          facetsCount: field.facetable ? (field.facetsCount ?? DEFAULT_FACETS_COUNT) : null,
          facetable: field.facetable ?? false,
          isDocumentLink: field.isDocumentLink
        }) as CpsFieldRequest
    );

    const updateViewRequest: UpdateViewRequest = {
      viewId: selectedView,
      name: selectedViewData.name,
      fields,
      globalFilters: editingViewState.globalFilters.map(filter => ({
        fieldId: filter.id,
        facetsCount: filter.facetsCount
      }))
    };

    showDialog({
      title: translate('custom.common.saveChangesTitle'),
      message: translate('custom.common.saveChangesMessage'),
      confirmButtonLabel: translate('custom.common.save'),
      discardButtonLabel: translate('custom.common.cancel'),
      onConfirm: confirmed => {
        if (confirmed) {
          onUpdateView(updateViewRequest);
          setHasUnsavedChanges?.(false);
        }
      }
    });
  };

  return { handleUpdateView };
};
